import React from "react";
import { Link } from "react-router-dom";

function Home() {
  document.title = "SimWealth";
  return (
    <>
      <div className="bg bg-home">
      <div className="container d-flex flex-column align-items-center justify-content-center vh-100">
            <div className="row d-flex justify-content-center align-items-center my-auto text-center w-100">
                <div className="bg-light py-3 mt-8">
                    <div className="col-12 heading-font h1 display-2">SimWealth</div>
                    <p className="text-danger heading-font display-6">Unlock the Secrets of True Wealth</p>
                </div>
                <Link data-aos="zoom-in" to={'/how-will-this-help-you'} className="btn btn-warning btn-lg px-5 border-3 border-white fw-bold inner-shadow w-25 mt-2">
                    Let’s Start
                </Link>
            </div>
        </div>
      </div>
    </>
  );
}

export default Home;
